import { render } from "./CataLogResource.vue?vue&type=template&id=43e2a9a9"
import script from "./CataLogResource.vue?vue&type=script&lang=js"
export * from "./CataLogResource.vue?vue&type=script&lang=js"

import "./CataLogResource.vue?vue&type=style&index=0&id=43e2a9a9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__